const luxy = require("luxy.js");

$(() => {
  try {
    luxy.init();
  } catch (error) {}
});
